import styled from "styled-components";
import { fadeIn } from "../../../utils/animations"
import media from "../../../utils/media"

export const loginWrapper = styled.div`
background: #F7F8FA 0% 0% no-repeat padding-box;
min-height: 100vh;
display: flex;
`
export const LoginGrid = styled.div`
display:flex;
margin-top: 150px;
margin-bottom: 150px;
padding-left: 40px;
padding-right: 40px;
flex-direction: column;
justify-content: center;
${media.tablet`padding-right: 20px`};
${media.tablet`padding-left: 20px`};
`

export const LoginHeader = styled.div`
background: #223564;
padding: 10px 15px;
color: #fff;
text-align: center;
`
export const LoginCard = styled.div`
background: #FFFFFF 0% 0% no-repeat padding-box;
border-top: 4px #223564 solid;
box-shadow: 3px 3px 10px #00000029;
`

export const StyledInput = styled.input`
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #DCDCDC;
border-radius: 9px;
padding: 10px 8px;
height: auto;
color: #000;
width: 100%;
font-size: 24px;
::placeholder,
::-webkit-input-placeholder {
    font-size: 24px;
  color: #CDCDCD;
}
:-ms-input-placeholder {
  color: #CDCDCD;
  font-size: 24px;
}
`
export const FormContainer = styled.div`
display: flex;
flex-direction: column;
padding-top: 50px;
padding-bottom: 20px;
width: 100%;
`

export const FormGroup = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
padding: 20px 40px;
${media.tablet`padding: 20px 20px;`};
`
export const SubmutButton = styled.button`
background: #223564 0% 0% no-repeat padding-box;
border-radius: 4px;
padding: 10px 8px;
border: none;
color: white;
cursor: pointer;
`

export const LoginSub = styled.p`
text-align: center;
font-Size: 18px;
font-weight: 900;
letter-spacing: -0.19px;
color: #091740;
margin-bottom: 30px;
`

export const ErrorSpan = styled.span`
color: red;
text-transform: capitalize;
animation: ${fadeIn} 0.3s linear 0s 1 normal none;
`
export const SuccessSpan = styled.span`
color: white;
text-transform: capitalize;
border-radius: 5px;
padding: 10px;
width: 100%;
text-aligh:center;
background: #4CE797;
animation: ${fadeIn} 0.3s linear 0s 1 normal none;
`